
<collapsible-section
    :id="`repeatable_collapse_${elementContainer.client_id}-${dropdownControlId}`"
    :control-name="`${elementContainer.referenceNameOrDefault}Collapse`"
    :is-open="isOpen(elementContainer.formElementsArray)"
>
  <template #section-header>
    <icon v-if="elementContainer.isDataCollection" class="infinity pr-1" color="Blue"></icon>
    {{ elementContainer.referenceNameOrDefault }}
  </template>

  <template #section-contents>
    <field-item
        v-if="handler.allowElementContainerSelection"
        :disabled="handler.isDisabled(elementContainer, parentTreeContext)"
        @click="select(elementContainer)"
    >
      <row>
        <prefix>
          <icon :glyph="elementContainer.controlIcon" />
        </prefix>
        <column>
          {{ elementContainer.referenceNameOrDefault }}
        </column>
        <suffix v-if="elementContainer.isDataCollection">
          <icon glyph="infinity" color="Blue" />
        </suffix>
      </row>
    </field-item>

    <component :is="elementsSectionWrapperOrDiv" :id="`elementsCollapse_${elementContainer.client_id}-${dropdownControlId}`" :is-open="!hasSearched || isOpen(elementContainer.formElementsArray)">
      <template v-for="element in childElements.sort((a, b) => a.is_repeatable ? 1 : 0)">
        <form-element-container-data
          v-if="recurse && isLayoutElement(element)"
          :key="`element-container-${element.client_id}-${dropdownControlId}`"
          :handler="handler"
          :element-container="element"
          :parent-tree-context="childTreeContext({parent: elementContainer})"
          recurse
          @select="el => select(el)"
        />

        <field-item
            v-else
            :key="`element-container-${element.client_id}-${dropdownControlId}`"
            :disabled="handler.isDisabled(element, childTreeContext({parent: elementContainer}))"
            @click="select(element)"
        >
          <row>
            <prefix>
              <icon :glyph="element.controlIcon" />
            </prefix>
            <column>
              {{ element.referenceNameOrDefault }}
            </column>
            <suffix v-if="element.is_repeatable">
              <icon glyph="infinity" color="Blue" />
            </suffix>
          </row>
        </field-item>
      </template>
    </component>

    <slot name="after-elements" />
  </template>
</collapsible-section>
